import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = { class: "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_3 = { class: "flex min-w-0 items-center gap-3.5" }
const _hoisted_4 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-emerald-100 bg-emerald-50" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-2.5" }
const _hoisted_7 = { class: "truncate text-xl font-bold tracking-tight text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-xs text-gray-600"
}
const _hoisted_9 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-3.5 py-2 text-xs font-medium text-gray-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode($setup["SVGWhatsApp"], { class: "h-7 w-7 text-[#25D366]" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString($props.title), 1 /* TEXT */),
            ($props.statusLabel)
              ? (_openBlock(), _createBlock(_component_UiBadge, {
                  key: 0,
                  variant: $props.statusVariant,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mr-1.5 inline-block h-1.5 w-1.5 rounded-full", {
                                    'bg-emerald-500': $props.statusVariant === 'emerald',
                                    'bg-amber-500': $props.statusVariant === 'yellow',
                                    'bg-gray-400': $props.statusVariant === 'gray',
                                }]),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString($props.statusLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["variant"]))
              : _createCommentVNode("v-if", true)
          ]),
          ($props.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($props.subtitle), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        ($props.summary)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($props.summary), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "actions")
      ])
    ])
  ]))
}